import "./styles.scss";
import React, { useEffect, useState } from "react";
import { Link } from "gatsby";

import PostAuthor from "./components/Author";
import SimpleAdCard from "components/SimpleAdCard";
import SimpleArticleCard from "components/SimpleArticleCard";

import { getColorVariant } from "utils";

import { usePosts } from "context/posts";

function getRandomArticles(array) {
  if (array.length <= 4) return array;

  const shuffledArray = [...array];

  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }

  return shuffledArray.slice(0, 4);
}

const PostContent = ({ data }) => {
  const { posts } = usePosts();
  const [random_articles, setRandomArticles] = useState([]);

  const category = data?.categories?.nodes[0];
  const other_posts = posts
    ?.filter((item) =>
      item?.categories?.nodes?.some((cat) => cat.slug !== "artykuly-partnerow")
    )
    ?.filter((item) => item?.slug !== data?.slug)
    .slice(0, 4);

  const category_posts = posts
    ?.filter((item) =>
      item?.categories?.nodes?.some((cat) => cat.slug !== "artykuly-partnerow")
    )
    ?.filter((item) => item?.slug !== data?.slug)
    ?.filter((item) =>
      item?.categories?.nodes?.some((cat) => cat.slug === category?.slug)
    )
    .slice(0, 4);

  useEffect(() => {
    const formatted_posts = posts?.filter((item) =>
      item?.categories?.nodes?.some((cat) => cat.slug !== "artykuly-partnerow")
    );

    const random_articles = getRandomArticles(formatted_posts);
    setRandomArticles(random_articles);
    // eslint-disable-next-line
  }, []);

  return (
    <section className="single-post-main">
      <div className="container">
        <div className="single-post-main__wrapper">
          <div
            className="single-post-main__content"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
          <PostAuthor data={data} />
        </div>
        <div className="single-post-main__aside">
          <div className="single-post-main__aside__item">
            <h2>Czytaj więcej porad Moniki Chrapińskiej-Krupa</h2>

            <div className="single-post-main__aside__items">
              {random_articles.map((item, index) => (
                <SimpleArticleCard
                  key={index}
                  url={item.uri}
                  image={item.featuredImage?.node?.sourceUrl}
                  title={item.title}
                  aside={item.date}
                />
              ))}
            </div>
          </div>
          {!!data.acfPost?.ad1Header && (
            <div className="single-post-main__aside__item single-post-main__aside__item--ad">
              <h2>
                <AdHeaderWrapper url={data?.acfPost?.ad1Link}>
                  {data.acfPost?.ad1Header}
                </AdHeaderWrapper>
              </h2>
              <div className="single-post-main__aside__items">
                <SimpleAdCard
                  url={data?.acfPost?.ad1Link}
                  image={data.acfPost?.ad1Image?.sourceUrl}
                  title={data.acfPost?.ad1Text}
                  // aside={item.date}
                />
              </div>
            </div>
          )}

          <div className="single-post-main__aside__item">
            <h2>Najnowsze artykuły</h2>

            <div className="single-post-main__aside__items">
              {other_posts.map((item, index) => (
                <SimpleArticleCard
                  url={item.uri}
                  image={item.featuredImage?.node?.sourceUrl}
                  title={item.title}
                  description="Opublikowano:"
                  aside={item.date}
                  variant={getColorVariant(index + 1)}
                  size="small"
                  type="other-post"
                  isEqual
                />
              ))}
            </div>
          </div>

          {!!data.acfPost?.ad2Header && (
            <div className="single-post-main__aside__item single-post-main__aside__item--ad">
              <h2>
                <AdHeaderWrapper url={data?.acfPost?.ad2Link}>
                  {data.acfPost?.ad2Header}
                </AdHeaderWrapper>
              </h2>
              <div className="single-post-main__aside__items">
                <SimpleAdCard
                  url={data?.acfPost?.ad2Link}
                  image={data.acfPost?.ad2Image?.sourceUrl}
                  title={data.acfPost?.ad2Text}
                  // aside={item.date}
                />
              </div>
            </div>
          )}
          {category_posts?.length > 0 && (
            <div className="single-post-main__aside__item">
              <h2>Podobne w kategorii</h2>

              <div className="single-post-main__aside__items">
                {category_posts.map((item, index) => (
                  <SimpleArticleCard
                    url={item.uri}
                    image={item.featuredImage?.node?.sourceUrl}
                    title={item.title}
                    description="Opublikowano:"
                    aside={item.date}
                    variant={getColorVariant(index + 1)}
                    size="small"
                    type="other-post"
                    isEqual
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

const AdHeaderWrapper = ({ url, children }) => {
  const isInternal = /^\/(?!\/)/.test(url);
  const Type = url ? (isInternal ? Link : "a") : "span";

  return (
    <Type
      to={url && isInternal ? url : undefined}
      href={url && !isInternal ? url : undefined}
      target={url && !isInternal ? "_blank" : undefined}
      rel={url && !isInternal ? "noreferrer nofollow" : undefined}
    >
      {children}
    </Type>
  );
};

export default PostContent;
